import { Box, Button, Container, IconButton, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import CenterLoader from "../../components/CenterLoader";
import { useFlips } from "../../contexts/FlipsDashboardContext";
import { UserContext } from "../../contexts/UserContext";
import { exportTableToCsv } from "../../taskUtils";
import { getColumns } from "./columns";
import Iconify from "../../../minimals/components/iconify";
import DeleteFlipConfirmationDialog from "./DeleteFlipConfirmationDialog";

export default function FlipsDashboard() {
  const { flips, loading, fetchFlips, isUpdatingInSelect, actionDisplayText, setActionDisplayText, setIsUpdatingInSelect } =
    useFlips();
  const { user } = useContext(UserContext);
  const normalizedUsername = user?.username?.toLowerCase().replace("workgroup\\", "");
  const canSeeDeleteButton =
    normalizedUsername === "miriam" || normalizedUsername === "afriedman" || normalizedUsername === "bfreylicher";
  const [orderNumberPendingDelete, setOrderNumberPendingDelete] = useState<string | null>(null);

  useEffect(() => {
    fetchFlips(true);
  }, []);

  const confirmDelete = async () => {
    if (!orderNumberPendingDelete) {
      return;
    }

    const orderNumberToDelete = orderNumberPendingDelete;
    setOrderNumberPendingDelete(null);
    setActionDisplayText("Deleting flip...");
    setIsUpdatingInSelect(true);
    try {
      await axios.post("/api/taskmanagement/flips/Delete", { orderNumber: orderNumberToDelete });
      await fetchFlips(true);
    } finally {
      setIsUpdatingInSelect(false);
      setActionDisplayText("Updating flip...");
    }
  };

  return (
    <>
      <Helmet>
        <title>Flips Dashboard | TitleQ</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" marginBottom={2}>
          Flips Dashboard
        </Typography>
        <MaterialReactTable
          enableStickyHeader
          columns={getColumns({
            canSeeDeleteButton,
            onDeleteClick: (orderNumber) => setOrderNumberPendingDelete(orderNumber)
          })}
          data={flips}
          enableGlobalFilter
          enableFacetedValues
          initialState={{
            density: "compact",
            pagination: { pageIndex: 0, pageSize: 30 }
          }}
          state={{ showSkeletons: loading }}
          muiTableBodyProps={{
            sx: {
              "& .MuiTableRow-root:hover .MuiTableCell-root": {
                backgroundColor: "inherit !important"
              }
            }
          }}
          muiTableBodyRowProps={({ row }) => {
            return {
              style: row.index % 2 === 0 ? { backgroundColor: "#f4f4f4", height: 60 } : { height: 60 }
            };
          }}
          renderTopToolbarCustomActions={({ table }) => {
            return (
              <>
                <Box display="flex" justifyContent="flex-end" width="100%">
                  <Tooltip title="Export to csv">
                    <IconButton onClick={() => exportTableToCsv(table, "export.csv")}>
                      <Iconify icon="eva:download-fill" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            );
          }}
        />
        <DeleteFlipConfirmationDialog
          orderNumber={orderNumberPendingDelete}
          isDeleting={isUpdatingInSelect}
          onClose={() => setOrderNumberPendingDelete(null)}
          onConfirm={confirmDelete}
        />
        <CenterLoader isOpen={isUpdatingInSelect} displayText={actionDisplayText} />
      </Container>
    </>
  );
}
